'use strict'

module.exports = { version: '8.4.0' }
